import React, {ReactNode, useState} from "react";
import {Link} from "react-router-dom";
import ChatCategoryModal from "./ChatCategoryModal";
import {openInModal} from "./ChatProductModal";

/**
 * Ссылка на раздел каталога в тексте ответа консультанта: открывает каталог раздела в модальном окне, чат остаётся на месте.
 */
export default function ChatCategoryLink({href, children}: {href: string, children: ReactNode}) {
    const [open, setOpen] = useState(false);

    return <>
        <Link className="chat-link" to={href} onClick={event => openInModal(event, () => setOpen(true))}>{children}</Link>
        <ChatCategoryModal href={href} show={open} onHide={() => setOpen(false)}/>
    </>;
}
